import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=0414daca&scoped=true"
import script from "./CustomerOrder.vue?vue&type=script&lang=js"
export * from "./CustomerOrder.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrder.vue?vue&type=style&index=0&id=0414daca&prod&scoped=true&lang=scss"
import style1 from "./CustomerOrder.vue?vue&type=style&index=1&id=0414daca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0414daca",
  null
  
)

export default component.exports